import { Theme } from '@mui/material'

import { getChatbotAccentColor } from '~/features/chatbot/utils'
import {
  EChatbotTheme,
  TChatbotSettingsLayout,
} from '~/features/settings/models'

export const getLayoutColors = (
  chatbotLayout: TChatbotSettingsLayout,
  theme: Theme,
) => {
  const selectedTheme = chatbotLayout.selection.theme
  const { accentColor: linkViewAccentColor } = getChatbotAccentColor({
    layout: chatbotLayout,
    selectedTheme: EChatbotTheme.linkView,
  })

  const wrapperBackgroundColor = {
    [EChatbotTheme.simple]:
      chatbotLayout.selection[chatbotLayout.selection.theme],
    [EChatbotTheme.linkView]: linkViewAccentColor,
  }[selectedTheme]

  const containerBackgroundColor = theme.palette.common.white

  return { wrapperBackgroundColor, containerBackgroundColor }
}

export default getLayoutColors
